<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
        const currencyList = [
            {
                label: 'CNY (ChiNese Yuan)',
                value: 'CNY'
            },
            {
                label: 'RMB (ChiNese Yuan)',
                value: 'RMB'
            },
            {
                label: 'USD (United States Dollar)',
                value: 'USD'
            },
            {
                label: 'EUR (Euro)',
                value: 'EUR'
            },
            {
                label: 'TRY (Yeni Turk Lirasi)',
                value: 'TRY'
            },
            {
                label: 'FRF (FRench Franc)',
                value: 'FRF'
            },
            {
                label: 'HKD (Hong Kong Dollar)',
                value: 'HKD'
            },
            {
                label: 'CHF (sCHweizer Franken)',
                value: 'CHF'
            },
            {
                label: 'CAD (CAnadian Dollar)',
                value: 'CAD'
            },
            {
                label: 'GBP (Great Britain Pound)',
                value: 'GBP'
            },
            {
                label: 'NLG (NetherLandish Guilder)',
                value: 'NLG'
            },
            {
                label: 'DEM (DEutsche Mark)',
                value: 'DEM'
            },
            {
                label: 'BEF (BElgischer Franc)',
                value: 'BEF'
            },
            {
                label: 'JPY (JaPanese Yen)',
                value: 'JPY'
            },
            {
                label: 'AUD (AUstralian Dollar)',
                value: 'AUD'
            },
        ];
		const options = currencyList.map(v => {
			return { value: v.value, label: v.label };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

